import styles from './index.module.less';
import Image from 'next/image';
import dayjs from 'dayjs';
import Link from 'next/link';

const Index: React.FC<any> = ({ data }) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.mainTitle}>{data.contentInfo['section-guide'].title}</h2>
      <div className={styles.desc}>{data.contentInfo['section-guide'].desc}</div>
      <ul className={styles.list}>
        {data.pageList?.map((item: any) => (
          <li className={styles.item} key={item.id}>
            <Link href={item.url_path} className={styles.itemLink}>
              <Image
                className={styles.itemImage}
                src={item.cover_image}
                alt={item.title}
                width={500}
                height={312}
                loading="lazy"
              />
              <div className={styles.itemContent}>
                <h3 className={styles.itemTitle}>{item.title}</h3>
                <div className={styles.itemDate}>{dayjs(item.date).format('MMMM D, YYYY')}</div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Index;
